import React, { Fragment, useRef } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import { isVideoAlbum } from '../../../../../util/album';
import SpecialtyEventUploadFinishMessage from '../../../SpecialtyEventUploadView/components/SpecialtyEventUploadFinishMessage';
import { getCelebratedPersonName } from '../../../../../apps/pro/views/AlbumFolder/FreemiumEvents/SpecialtyAlbumGreetingModal/helpers';
import SpecialtyAlbumGreeting from '../../../../../apps/pro/views/AlbumFolder/FreemiumEvents/SpecialtyAlbumGreetingModal/SpecialtyAlbumGreeting';
import {
  canViewSpecialtyEventAlbums,
  getSpecialtyAlbumInviteNames,
} from '../../../SpecialtyEventUploadView/helpers';
import { fileInputAccept } from '../../../../../constants/photo-upload';
import Button from '../../../../../components/global/Button';

const propTypes = {
  album: PropTypes.shape({
    id: PropTypes.string,
  }).isRequired,
  uploadedTargets: PropTypes.array.isRequired,
  onUpload: PropTypes.func.isRequired,
  onVideoUpload: PropTypes.func.isRequired,
  success: PropTypes.bool.isRequired,
};

const HomeStep = ({
  album,
  uploadedTargets,
  onUpload,
  onVideoUpload,
  success,
}) => {
  const inputRef = useRef();
  const history = useHistory();
  const { root_album_folder: albumFolder } = album ?? {};

  const possessiveCelebratedName = getCelebratedPersonName(
    albumFolder?.album_subtype,
    albumFolder?.event_settings,
    true,
    albumFolder?.account?.organization_name ?? albumFolder?.account?.name,
  );

  const genericAlbumName = getSpecialtyAlbumInviteNames([album])[0];

  const canView = canViewSpecialtyEventAlbums(
    [album],
    albumFolder?.event_settings,
  );

  return (
    <Fragment>
      <div className="d-flex flex-column align-items-center justify-content-center">
        {success ? (
          <Fragment>
            <h2 className="text-black mb-2 text-center">Success!</h2>
          </Fragment>
        ) : (
          <Fragment>
            <h5 className="mb-1 text-center text-uppercase text-light">
              Welcome to
            </h5>
            <h2 className="text-black mb-2 text-center">
              {possessiveCelebratedName}
              <br />
              {genericAlbumName}!
            </h2>
            <div className="text-center">
              <SpecialtyAlbumGreeting
                headerless
                dismissible={false}
                albumId={album.id}
                onAddPhotos={() => {
                  if (isVideoAlbum(album)) {
                    onVideoUpload();
                  } else {
                    inputRef?.current?.click();
                  }
                }}
              />
              <input
                id="uploader"
                type="file"
                className="d-none"
                accept={fileInputAccept}
                multiple
                onChange={event => {
                  onUpload([...event.target.files]);
                }}
                ref={inputRef}
              />
            </div>
          </Fragment>
        )}
      </div>
      {uploadedTargets.length > 0 && (
        <Fragment>
          <SpecialtyEventUploadFinishMessage
            uploadedTargets={uploadedTargets}
            possessiveCelebratedName={possessiveCelebratedName}
          />

          {canView && (
            <Fragment>
              <hr className="w-100 mt-0 my-2" />
              <h5 className="my-1 text-center text-uppercase text-primary">
                What&apos;s next?
              </h5>
              <Button
                btnOutline
                onClick={() => history.push(`/albums/${album.id}/slideshow`)}
                className="mt-1"
                btnBlock
              >
                View {genericAlbumName}
              </Button>
            </Fragment>
          )}
        </Fragment>
      )}
    </Fragment>
  );
};

HomeStep.propTypes = propTypes;

export default HomeStep;
